import $ from 'jquery';
import SvgDelayLoadClass from './SvgDelayLoadClass';
import ThingsManagerClass from '../base/ThingsManagerClass';

/**
 * SvgDelayLoad一括管理
 * @param {String} _target 対象となるクラス名やid名 デフォルトbody
 * @example
 * //divの中身にsvgファイルの中身が出力されます
 * //アニメーション有り
 * <div class="js-svgDelayLoad" data-src="./img/test.svg"></div>
 *      pc->./img/test.svg
 *      sp->./img/sp/test.svg
 *
 * //アニメーション無し
 * <div class="js-svgDelayLoad_noAnim" data-src="./img/test.svg"></div>
 *
 * //PCとSPでファイル名が違う場合
 * <div class="js-svgDelayLoad or js-svgDelayLoad_noAnim" data-src="./img/test.svg" data-src_sp="./img/test2.svg"></div>
 */
export default class SvgDelayLoadManagerClass extends ThingsManagerClass {
  constructor(_target) {
    super();
    this.name = 'SvgDelayLoadManagerClass';
    this._target = (_target) ? _target : 'body';
  }

  onCreate() {
    let self = this;
    let target = $(this._target);
    $('.js-svgDelayLoad', target).each((index, element) => {
      self.things.push(new SvgDelayLoadClass($(element), true));
    });
    $('.js-svgDelayLoad_noAnim', target).each((index, element) => {
      self.things.push(new SvgDelayLoadClass($(element), false));
    });
    super.onCreate();
  }
}
